import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormField from '../FormField';
import { FiPlus, FiMinus } from 'react-icons/fi';

export default function GovernancaInvestimentos({ repeatableFields, addRepeatableField, removeRepeatableField }) {
  const { watch } = useFormContext();
  
  return (
    <div>
      <div className="mb-6 p-4 bg-blue-50 rounded-lg">
        <p className="text-sm text-blue-700">Esta seção coleta informações sobre governança e investimentos do município, incluindo capacidade de investimento e parcerias público-privadas.</p>
      </div>

      <div className="mt-4">
        <FormField
          name="investimento_capacidade"
          label="Capacidade de investimento municipal (% do orçamento)"
          type="percent"
          placeholder="Digite a porcentagem"
          helpText="Porcentagem do orçamento municipal destinada a investimentos"
          validation={{
            min: {
              value: 0,
              message: 'O valor deve ser maior ou igual a 0',
            },
            max: {
              value: 100,
              message: 'O valor deve ser menor ou igual a 100',
            },
          }}
        />
      </div>
      
      <div className="mt-6">
        <h3 className="text-md font-medium mb-3">Parcerias Público-Privadas (PPPs)</h3>
        
        {/* Campos repetíveis para PPPs */}
        {repeatableFields.ppp.map((item) => (
          <div key={item.id} className="mb-6 p-4 border border-gray-200 rounded-lg">
            <div className="flex justify-between items-center mb-2">
              <h3 className="text-md font-medium">PPP {item.id}</h3>
              {item.id !== 1 && (
                <button 
                  type="button" 
                  onClick={() => removeRepeatableField('ppp', item.id)}
                  className="text-red-500 hover:text-red-700"
                >
                  <FiMinus className="mr-1" /> Remover
                </button>
              )}
            </div>

            <div className="mt-2">
              <FormField
                name={`ppp_exemplo_${item.id}`}
                label="Exemplo de PPP em infraestrutura"
                type="textarea"
                placeholder="Descreva um exemplo de PPP em infraestrutura"
                helpText="Detalhes sobre o projeto, investimento, duração, resultados, etc."
              />
            </div>
          </div>
        ))}
        
        <div className="mb-4">
          <button 
            type="button" 
            onClick={() => addRepeatableField('ppp')}
            className="flex items-center text-blue-600 hover:text-blue-800"
          >
            <FiPlus className="mr-1" /> Adicionar outra PPP
          </button>
        </div>
      </div>
      
      <div className="mt-6">
        <FormField
          name="orcamento_participativo"
          label="Existência de orçamento participativo"
          type="radio"
          options={[
            { value: 'sim', label: 'Sim' },
            { value: 'nao', label: 'Não' },
          ]}
          helpText="Indique se o município possui mecanismos de orçamento participativo"
        />
      </div>
      
      <hr className="border-t border-gray-300 my-6" />
      <div className="mt-6 space-y-4">
        <FormField
          name="fontes_principais_secao9"
          label="Fontes principais"
          type="textarea"
          placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
          helpText=""
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
        
        <FormField
          name="links_acesso_secao9"
          label="Links de acesso"
          type="textarea"
          placeholder="Insira os links para acesso às fontes"
          helpText="Informe URLs para acesso às fontes quando disponível"
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
      </div>
    </div>
  );
}
